import { CloseOutlined } from "@mui/icons-material";
import React from "react";
import styled from "styled-components";
import { BOX_SHADOW, PRIMARY, SECONDARY } from "../const/colors";
import { setCompletedBono } from "../features/user/userSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 1100000;
  position: fixed;
  background: #00000099;

  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    color: #fff;
    font-size: 2.5rem;
    text-transform: uppercase;
    text-align: center;
  }
  
  div {
    position: relative;
    background: ${SECONDARY};
    width: 60%;
    box-shadow: ${BOX_SHADOW};
    border: 1px solid ${PRIMARY};
    border-radius: 1rem;
    padding: 4rem 2rem;
    padding-bottom: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  img {
    position: absolute;
    width: 100vw;
    height: 100vh;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
  }

  svg {
    color: #fff;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }

  img.stars-mob {
    display: none;
  }

@media screen and (max-width: 1080px) {
  div {
    width: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit:fill;
  }

  h2 {
    font-size: 1.8rem;
  }

  svg {
    font-size: 2rem;
  }
}

@media screen and (max-width: 780px) {

  img.stars-desk {
    display: none;
  }
  img.stars-mob {
    display: block;
  }

}
`;

export const ButtonSpecial = styled.button`
  font-size: 1rem;
  font-weight: 600;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.5rem 1.5rem;
  margin-top:2rem;
  cursor: pointer;
`;
// ¡Felicidades tu bonificación fue acreditada!
const CompletedBonoEffect = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation('global');
  return (
    <Container>
      <div>
        <h2>{t('bonos.bono-completed')}</h2>
        <ButtonSpecial onClick={()=>{dispatch(setCompletedBono(false))}}>OK</ButtonSpecial>
      </div>
      <img className="stars-desk" src='/images/stars.gif' alt=''/>
      <img className="stars-mob" src='/images/estrellas-mob.gif' alt=''/>
    </Container>
  );
};

export default CompletedBonoEffect;
